











import { Component, Prop, Vue } from 'vue-property-decorator';
import { DashboardTab } from './DashboardTab';
import { DataType } from '@/core/data/DataType';

import StatEnterExitFilter from '../stats/StatEnterExitFilter.vue';
import TableEnterExit from '../tables/TableEnterExit.vue';
import { EnterExitColoredRecord } from '@/core/data/sets/computed/EnterExitColoredRecord';


@DashboardTab("Вход и выход", '<i class="fas fa-door-open"></i>', 'enter-exit', [DataType.EnterExitDaily, DataType.EnterExitHourly])
@Component ({
  components: {
    StatEnterExitFilter,
    TableEnterExit,
  }
})
export default class extends Vue {
  public filteredDates: string[] = EnterExitColoredRecord.getAllDates();
  public filteredPlaces: string[] = EnterExitColoredRecord.getAllPlaces();
}

